export const PromptSuggestions = ({ suggestions, onSelect, disabled }) => (
  <div className="flex flex-wrap justify-center gap-2">
    {suggestions.map((suggestion) => (
      <button
        key={suggestion.prompt}
        type="button"
        className="border-border/70 bg-card/80 hover:border-primary/50 hover:bg-primary/10 rounded-full border px-3 py-1.5 text-xs transition-colors disabled:pointer-events-none disabled:opacity-50"
        onClick={() => onSelect(suggestion.prompt)}
        disabled={disabled}
      >
        {suggestion.label}
      </button>
    ))}
  </div>
);
